import {MediaCardType} from '@wandb/weave/common/types/media';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {KeyTypes} from './common';
import {
  MediaBrowserPanelProps,
  MediaConfigWithDefaults,
  SizingSettings,
} from './Component';
import {PanelSettings} from './PanelSettings';

type PanelBodyProps = {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  panelSettings?: React.ReactNode;
  configMode: boolean;
  panelViewerRef: React.MutableRefObject<HTMLDivElement | null>;
  mediaType: MediaCardType | null;
  sizingSettings: SizingSettings;
  configWithDefaults: MediaConfigWithDefaults;
  allMediaKeys: string[];
  keyTypes: KeyTypes;
  numericKeys: string[];
  updateConfig: MediaBrowserPanelProps['updateConfig'];
  mediaBrowserRefCallback: (el: HTMLDivElement) => void;
};

// Create a panel body function so we can render our errors within
// the panel body and allow the panel to remain configurable
// on all error states
const PanelBodyComp = ({
  header,
  footer,
  children,
  configMode,
  panelViewerRef,
  mediaType,
  sizingSettings,
  configWithDefaults,
  allMediaKeys,
  keyTypes,
  numericKeys,
  updateConfig,
  mediaBrowserRefCallback,
}: PanelBodyProps) => {
  // FIXME: the sum below is the height of the headers above the media browser
  const content = (
    <div className="flex h-full flex-col">
      <div>{header}</div>
      <div
        className="flex h-full flex-col overflow-hidden"
        style={{
          maxHeight:
            /**
             * 60px account selector header
             * 57px workspace header
             * 12px panel padding top
             * 12px panel padding bottom
             * 2px panel border top and bottom
             * 32px panel header height
             * 18px panel header margin bottom height
             * 30px panel title height
             */
            'calc(100vh - 60px - 57px - 12px - 12px - 2px - 32px - 18px - 30px)',
        }}>
        <div
          className="panel-media shrink overflow-auto"
          ref={mediaBrowserRefCallback}>
          <div ref={panelViewerRef} className="panel-viewer">
            {children}
          </div>
        </div>
        <div className="shrink-0">{footer}</div>
      </div>
    </div>
  );

  if (configMode) {
    return (
      <Tailwind>
        <div className="panel-media__config-container">
          <div className="panel-media__config-content">{content}</div>
          <div className="panel-media__config-settings">
            <PanelSettings
              mediaType={mediaType}
              sizingSettings={sizingSettings}
              allMediaKeys={allMediaKeys}
              numericKeys={numericKeys}
              config={configWithDefaults}
              updateConfig={updateConfig}
              keyTypes={keyTypes}
            />
          </div>
        </div>
      </Tailwind>
    );
  }

  return (
    <div data-test="media-panel" className="panel-media__container">
      {content}
    </div>
  );
};

export const PanelBody = React.memo(PanelBodyComp);
